<script>
import CustomerFormDesktopView from "./CustomerFormDesktopView.vue";

/**
 * Desktop customer-form layout bridge.
 * Renders CustomerFormDesktopView using the parent customerForm instance as
 * context so template bindings and $refs stay on customer.vue (provide/inject).
 */
export default {
  name: "CustomerFormDesktopBridge",
  inject: ["customerForm"],
  render() {
    const customerForm = this.customerForm;
    const viewOptions = CustomerFormDesktopView.options || CustomerFormDesktopView;
    const render = viewOptions.render;

    if (!customerForm || typeof render !== "function") {
      return null;
    }

    const options = customerForm.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(customerForm, customerForm.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
